<template>
    <div class="popover-container">
        <i :id="label + 'popover'" class="fa fa-info-circle ml-2" aria-hidden="true"> </i>
        <b-popover :target="label + 'popover'" triggers="hover" placement="right">
            <template v-slot:title>{{ label }}</template>
            <div
                v-html="field.description"
                class="popover-content"
            ></div>
        </b-popover>
    </div>
</template>

<script>
export default {
    props: ['label', 'field'],
};
</script>

<style lang="scss">
.popover-container {
    display: inline;
}
.popover-content {
    p {
        img {
            max-width: 250px;
            display: block;
            margin: auto;
        }
    }
}
</style>